module.exports = __webpack_public_path__ + "img/stand length.5a30815b.png";